import { render, staticRenderFns } from "./BLContainerOOGPop.vue?vue&type=template&id=74922423"
import script from "./BLContainerOOGPop.vue?vue&type=script&lang=js"
export * from "./BLContainerOOGPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74922423')) {
      api.createRecord('74922423', component.options)
    } else {
      api.reload('74922423', component.options)
    }
    module.hot.accept("./BLContainerOOGPop.vue?vue&type=template&id=74922423", function () {
      api.rerender('74922423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLContainerOOGPop.vue"
export default component.exports